<div class="additional-resources-container">
    <div class="widget-header">
        <span>{{ "landing.additionalresources" | cxTranslate }}</span>
    </div>
    <div class="widget-content">
        <div class="widget-content-header">
            {{ "landing.othertools" | cxTranslate }} 
        </div>
        <div class="content-links-holder">
            <ul class="content-links mr-5" *ngFor="let chunkedLinks of chunkedLinkComponents">
                <li *ngFor="let link$ of chunkedLinks">
                    <a *ngIf="link$ | async as link" class="link" [href]="link.url" target="_blank">
                        <span>{{ link.linkName }}</span>
                        <i class='material-icons ml-1'>open_in_new</i></a>
                </li>
            </ul>
        </div>
    </div>
</div>